import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { MutationQuery } from 'src/app/shared/types/mutation-query.enum';

@Component({
	selector: 'bt-set-final-cost-modal',
	standalone: false,
	templateUrl: './set-final-cost-modal.component.html',
	styleUrls: ['./set-final-cost-modal.component.scss']
})
export class SetFinalCostModalComponent {
	data: { orderId: number; finalCost?: number | null; totalSku?: number | null };

	loading: boolean = false;
	finalCost: number | null = null;
	totalSku: number = 0;

	constructor(
		private dialogRef: MatDialogRef<SetFinalCostModalComponent>,
		@Inject(MAT_DIALOG_DATA) data: { orderId: number; finalCost?: number | null; totalSku?: number | null },
		private graphQLService: GraphQLService,
		private utilitiesService: UtilitiesService
	) {
		this.data = data;
		this.finalCost = this.data?.finalCost ?? null;
		this.totalSku = this.data?.totalSku ?? 0;
	}

	get singleSkuCost(): number | null {
		if (this.finalCost === null || this.finalCost === undefined || Number.isNaN(this.finalCost)) {
			return null;
		}

		if (!this.totalSku || this.totalSku <= 0) {
			return null;
		}

		return this.finalCost / this.totalSku;
	}

	close(): void {
		this.dialogRef.close();
	}

	save(): void {
		if (!this.data?.orderId) {
			this.utilitiesService.showSnackbar('Order ID is missing', SnackbarType.Error);
			return;
		}

		if (this.finalCost === null || this.finalCost === undefined || Number.isNaN(this.finalCost) || this.finalCost < 0) {
			this.utilitiesService.showSnackbar('Please insert a valid final cost', SnackbarType.Error);
			return;
		}

		this.loading = true;
		this.graphQLService
			.postData(MutationQuery.SET_FINAL_COST, {
				setFinalCostInput: {
					finalCost: this.finalCost,
					orderId: this.data.orderId
				}
			})
			.subscribe({
				next: (result: any) => {
					this.loading = false;
					if (result?.data?.setFinalCost?.success) {
						this.utilitiesService.showSnackbar(result?.data?.setFinalCost?.message || 'Final cost updated successfully', SnackbarType.Success);
						this.dialogRef.close(this.finalCost);
						return;
					}

					this.utilitiesService.showSnackbar(result?.data?.setFinalCost?.message || 'Failed to update final cost', SnackbarType.Error);
				},
				error: (err) => {
					this.loading = false;
					this.utilitiesService.showSnackbar(err?.networkError?.error?.errors?.[0]?.message || 'Error during final cost update', SnackbarType.Error);
					console.error(err);
				}
			});
	}
}
